import { Component } from '@angular/core';
import { NavParams, PopoverController, ViewController } from 'ionic-angular';
import 'rxjs';
import { AlertService } from '../../../providers/alert-service';
import { ArquivosService } from '../../../providers/arquivos-service';
import { FileService } from '../../../providers/file-service';
import { GestaoPcaService } from "../../../providers/gestao-pca-service";
import { UsuarioService } from "../../../providers/usuario-service";
import { PopoverAssinantesPage } from "../../popovers/popover-assinantes";
import { PopoverOptions } from "ionic-angular/components/popover/popover-options";
import { ControlesInternosService } from "../../../providers/controles-internos-service";
import { AGORA } from "../../../app/AGORA";
import { environment } from '../../../environments/environment';
import { OpcoesAssinatura } from '../../../assinatura/opcoes-assinatura.model';
declare var dtjava: any;

@Component({
  selector: 'page-modal-nao-se-aplica',
  templateUrl: 'modal-nao-se-aplica.html',
  providers: [
    ControlesInternosService,
    AGORA
  ]
})
export class ModalNaoSeAplicaPage {

  PCAAtiva: any;

  loading: boolean = true;
  titulo: any;
  isJurisdicionado: any;
  isCGE: any;

  moduloPca: any;
  moduloAnalise: any;

  IdProcesso: any = null;
  tipoAnalise: any = null;
  tipoEntidadeExercicio: any = null;
  tipoDocumento: any = null;
  tiposAceitos: any = "application/pdf";
  listaArquivosPCA: any;
  origemArquivo: any;
  listaPecasProcessuaisObrigatoria: any[];
  origemModal: boolean = false;
  origemFilter: any;

  usuarioLogado: any;

  disableFileInput: boolean = false;

  opcoes: OpcoesAssinatura;

  constructor(
    public AGORA: AGORA,
    private alertService: AlertService,
    public popoverCtrl: PopoverController,
    private fileService: FileService,
    private viewCtrl: ViewController,
    public navParams: NavParams,
    public arquivoService: ArquivosService,
    public gestaoPcaService: GestaoPcaService,
    public usuarioService: UsuarioService) {

    this.usuarioLogado = this.usuarioService.obtemUsuario();

    this.moduloPca = this.navParams.get('moduloPca');
    this.moduloAnalise = this.navParams.get('moduloAnalise');
    this.isJurisdicionado = this.navParams.get('jurisdicionado');
    this.isCGE = this.navParams.get('isCGE');
    this.titulo = this.navParams.get('titulo');

    this.IdProcesso = this.navParams.get('IdProcesso');
    this.tipoAnalise = this.navParams.get('tipoAnalise');

    this.tipoEntidadeExercicio = this.navParams.get('tipoEntidadeExercicio');
    this.tipoDocumento = this.navParams.get('tipoDocumento');

    this.origemFilter = this.navParams.get('origemFilter');

    if (this.navParams.get('origemArquivo') != undefined && this.navParams.get('origemArquivo') != null) {
      this.origemArquivo = this.navParams.get('origemArquivo');
    } else {
      this.origemArquivo = 'NA';
    }

    if (this.navParams.get('origemFilter') != undefined) {
      this.origemFilter = this.navParams.get('origemFilter');
    } else {
      this.origemFilter = null;
    }

    this.PCAAtiva = this.gestaoPcaService.getPCA();

    this.carregarModal();

    this.inicarOpcoesAssinatura();
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

  carregarModal() {
    this.listarArquivosPCA();
  }

  listarArquivosPCA() {

    let moduloPcaTemp = null;

    if (this.moduloPca) {
      moduloPcaTemp = this.moduloPca.moduloPca;
    }

    if (this.moduloAnalise) {
      moduloPcaTemp = this.moduloAnalise.moduloPca;
    }

    this.arquivoService.listarPecasVinculadasPCA(this.IdProcesso, moduloPcaTemp, this.tipoAnalise, false).subscribe(data => {

      if (this.tipoEntidadeExercicio != undefined && this.tipoEntidadeExercicio != 0) {
        this.listaArquivosPCA = data.filter((arquivo) => arquivo.peca.idTipoEntidadeExercicio == this.tipoEntidadeExercicio);
      } else {
        this.listaArquivosPCA = data;
      }
      this.loading = false;
    }, error => {
      this.loading = false;
      this.alertService.mostraAlerta("", "Ocorreu um erro ao listar os arquivos:" + error);
    });

    this.arquivoService.listarPecasProcessuaisObrigatoria(moduloPcaTemp).subscribe(data => {
      this.listaPecasProcessuaisObrigatoria = data;

      this.arquivoService.listarPecasProcessuaisNObrigatoria(moduloPcaTemp).subscribe(data2 => {

        if (data2.length > 0) {
          this.listaPecasProcessuaisObrigatoria.push(data2);
        }

        if (this.origemFilter != null) {
          //this.tipoDocumento = this.origemFilter;
          this.tipoDocumento = this.listaPecasProcessuaisObrigatoria.filter((tipo) => tipo.nmTipoDocumento == this.origemFilter)[0];
        }

        if (!this.isCGE) {
          if (this.tipoAnalise == '0' || this.tipoDocumento != null || this.tipoDocumento != undefined || this.tipoDocumento != '') {
            this.disableFileInput = false;
          } else {
            this.disableFileInput = true;
          }
        }
      }, error => console.log("erro: " + error));

    }, error => console.log("erro: " + error));
  }

  onTipoDocumentoChange(item) {

    if (item) {
      this.tipoEntidadeExercicio = item.idTipoEntidadeExercicio;
      this.tipoDocumento = item.idTipoDocumento;
    }

    if (!this.isCGE) {
      this.disableFileInput = false;
    }
  }

  baixarArquivo(arquivo) {
    this.loading = true;
    this.fileService.baixarArquivo(arquivo);
    this.loading = false;
  }

  fileChange(event) {
    this.alertService.mostraModalConfirmacao("Salvar Peça", "Arquivo selecionado, confirma importação ?", callback => {
      if (callback) {

        let fileList: FileList = event.target.files;
        if (fileList.length > 0) {
          let file: File = fileList[0];

          if (file.size <= 10485760) {

            let moduloPca = null;

            if (this.moduloPca) {
              moduloPca = this.moduloPca.moduloPca;
            }

            if (this.moduloAnalise) {
              moduloPca = this.moduloAnalise.moduloPca;
            }

            this.fileService.salvarPeca(file, this.IdProcesso, moduloPca, 0, 0, 0, this.origemArquivo).subscribe(data => {
              this.alertService.mostraAlerta("", "Arquivo adicionado com sucesso!");
              this.carregarModal();

              if (this.tipoAnalise != 0 && !this.isCGE) {
                this.disableFileInput = true;
              }
            }, error => {
              this.alertService.mostraAlerta("", "Ocorreu um erro ao salvar arquivo: " + error.mensagem);
            });
          } else {
            this.alertService.mostraAlerta("", "Arquivo ultrapassou o limite de tamanho de 10Mb.");
          }
        }
      }
    });
  }

  deletarArquivo(idArquivo, nomeArquivo) {

    this.alertService.mostraModalConfirmacao("Excluir Arquivo", "Você tem certeza que deseja excluir o arquivo " + nomeArquivo + "?",
      retornoModal => {
        if (retornoModal) {
          this.fileService.deletarArquivo(idArquivo).subscribe(data => {
            this.alertService.mostraAlerta("", "Arquivo excluído com sucesso.");
            this.carregarModal();
            //this.listarArquivosPCA();
          }, error => {
            this.alertService.mostraAlerta("", "Houve um erro ao excluir arquivo.");
          });
        }
      }
    );
  }

  /*assinarArquivos(arquivo) {

    // Assinar arquivo
    let assinar = this.AGORA.assinarArquivos(arquivo.idArquivoVinculado, this.PCAAtiva.id, this.usuarioLogado.dadosUsuario[0].cpf,this.usuarioService.obterDadosUsuario().perfil);
    assinar.subscribe(
      next => {
        console.log('Sucesso: %s', next);
        this.dismiss();
      },
      error => {
        console.log('Erro: %s', error);
        this.alertService.mostraAlerta("Erro encontrado", error);
      });

  }
  */

  validacaoForm(tipoModulo: string): boolean {
    if(tipoModulo === 'moduloPca') {
      if (this.moduloPca.flNaoAplica == "true"){
        if ((typeof this.moduloPca.dsJustificativa === "undefined" || this.moduloPca.dsJustificativa == "") || this.listaArquivosPCA.length <= 0) {
          return true;
        }
      }
    } else {
      if (this.moduloAnalise.flNaoAplica == "true"){
        if ((typeof this.moduloAnalise.dsJustificativa === "undefined" || this.moduloAnalise.dsJustificativa == "") || this.listaArquivosPCA.length <= 0) {
          return true;
        }
      }
    }

    return false;
  }

  salvarModuloPca() {
    if (this.validacaoForm('moduloPca')) {
      this.alertService.mostraAlerta("Erro", "Ausência da Justificativa ou evidência.");
    } else {
      this.gestaoPcaService.justificarModulo(this.moduloPca).subscribe(data => {
        this.alertService.mostraAlerta("", "Salvo com sucesso!");
        this.dismiss();
      }, error => {
        this.alertService.mostraAlerta("", "Ocorreu um erro ao salvar." + error.mensagem);
      });
    }
  }

  salvarModuloAnalise() {
    if (this.validacaoForm('moduloAnalise')) {
      this.alertService.mostraAlerta("Erro", "Ausência da Justificativa ou evidência.");
    } else {
      this.gestaoPcaService.justificarModuloAnalise(this.moduloAnalise).subscribe(data => {
        this.alertService.mostraAlerta("", "Salvo com sucesso!");
        this.dismiss();
      }, error => {
        this.alertService.mostraAlerta("", "Ocorreu um erro ao salvar." + error.mensagem);
      });
    }
  }

  retornoAssinatura() {
    console.log("RETORNO ASSINATURA");
  }

  messageFuncion() {
    console.log("RETORNO MESSAGE FUNCTIONS");
  }

  exibirAssinantes(myEvent, assinantesParam) {
    let options: PopoverOptions = {
      cssClass: "popover-assinantes",
      showBackdrop: false,
      enableBackdropDismiss: false
    };
    let assinantes = new Array<any>();
    assinantes = assinantesParam;

    let popover = this.popoverCtrl.create(PopoverAssinantesPage, { assinantes: assinantes }, options);
    popover.present({
      ev: myEvent
    });
  }

  inicarOpcoesAssinatura() {

    const cpf = environment.production ? this.usuarioLogado.dadosUsuario[0].cpf : environment.cpfAssinateTeste;

    this.opcoes = {
      arquivos: [],
      cpfUsuarioLogado: cpf,
      urlBackEndCallBack: environment.urlBackEndCallBackAssinatura,
      dadosBackEndCallBack: [],
      idPca: this.PCAAtiva.id,
      tipoArquivo: 'TIPO_VINCULADO'
    };
  }

  marcarArquivoParaAssinar(evento: any, arquivo: any) {

      if (evento.checked) {
        this.incluirArquivoNasOpcoesAssinatura(arquivo.pathArquivo);
        this.incluirArquivoNosDadosDoCallBackAssinatura(arquivo);
      } else {
        this.removerArquivoDasOpcoesAssinatura(arquivo.pathArquivo);
        this.removerArquivoDosDadosDoCallBackAssinatura(arquivo);
      }
  }

  private incluirArquivoNasOpcoesAssinatura(caminho: string) {
    this.opcoes.arquivos.push(caminho);
  }
  private removerArquivoDasOpcoesAssinatura(caminho: string) {
    this.opcoes.arquivos = this.opcoes.arquivos.filter(c => {
      return caminho !== c;
    });
  }

  private incluirArquivoNosDadosDoCallBackAssinatura(arquivo: any) {
    this.opcoes.dadosBackEndCallBack.push({
      idPca: this.PCAAtiva.id,
      idDocumento: arquivo.idArquivoVinculado,
      cpfAssinante: this.formatarCpf(this.usuarioLogado.dadosUsuario[0].cpf),
      perfil: this.usuarioService.obterDadosUsuario().perfil
    });
  }
  private removerArquivoDosDadosDoCallBackAssinatura(arquivo: any) {
    this.opcoes.dadosBackEndCallBack = this.opcoes.dadosBackEndCallBack.filter(a => {
      return a.idDocumento !== arquivo.idArquivoVinculado;
    });
  }

  private formatarCpf(valor) {
    return valor.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, "\$1.\$2.\$3\-\$4");
  }

  sucesso(evento: any) {
    this.carregarModal();
    this.inicarOpcoesAssinatura();
  }

  isAbilitarBotaoAssinatura() {
    return this.opcoes.arquivos.length > 0;
  }
}



// WEBPACK FOOTER //
// ./src/pages/modais/nao-se-aplica/modal-nao-se-aplica.ts